<app-dialog
  [title]="title"
  [actions]="[
  { text: 'Cancel', buttonStyle: 'underline' },
    {
      text: 'Save',
      isDisabled: !productForm.valid,
      spin: spin
    }]"
  (action)="action($event)"
  (close)="close()"
>
  <div class="dialog-container">
    <div class="top">
      <div
        class="top_image"
        [style.backgroundImage]="
          'url(' +
          (product && product.imageUrl
            ? product.imageUrl
            : '' || 'assets/images/No_image.png') +
          ')'
        "
      ></div>
      <div class="top_form" [formGroup]="productForm">
        <div class="input-container">
          <label for="" class="input-container_label">Name*</label>
          <input
            type="text"
            class="input-container_input"
            formControlName="name"
          />
          <div
          class="input-container_error-message"
          *ngIf="productForm.controls['name'].errors?.unique"
        >
          Item name already exists for this vendor
        </div>
        </div>

        <div class="input-container">
          <label for="" class="input-container_label">Description</label>
          <input
            type="text"
            class="input-container_input"
            formControlName="title"
          />
        </div>

        <div class="input-container">
          <label for="" class="input-container_label">Image URL</label>
          <input
            type="text"
            class="input-container_input"
            formControlName="imageUrl"
            (blur)="updateImage()"
          />
        </div>

        <div class="input-container">
          <label for="" class="input-container_label">Default Location</label>
          <input
            type="text"
            class="input-container_input"
            formControlName="defaultLocation"
          />
        </div>

        <div class="input-container">
          <label for="" class="input-container_label">Brand</label>
          <input
            type="text"
            class="input-container_input"
            formControlName="brand"
          />
        </div>

        <div class="input-container">
          <label for="" class="input-container_label">Model</label>
          <input
            type="text"
            class="input-container_input"
            formControlName="model"
          />
        </div>

        <div class="input-container">
          <label for="" class="input-container_label">Color</label>
          <input
            type="text"
            class="input-container_input"
            formControlName="color"
          />
        </div>

        <div class="input-container">
          <label for="" class="input-container_label">UPC</label>
          <input
            type="text"
            class="input-container_input"
            formControlName="upc"
          />
        </div>

        <div class="input-container">
          <label for="" class="input-container_label">L <span class="gray"> (inch)</span></label>
          <input
            type="number"
            class="input-container_input"
            formControlName="length"
          />
        </div>

        <div class="input-container">
          <label for="" class="input-container_label">W <span class="gray"> (inch)</span></label>
          <input
            type="number"
            class="input-container_input"
            formControlName="width"
          />
        </div>

        <div class="input-container">
          <label for="" class="input-container_label">H <span class="gray"> (inch)</span></label>
          <input
            type="number"
            class="input-container_input"
            formControlName="height"
          />
        </div>

        <div class="input-container">
          <label for="" class="input-container_label">Weight <span class="gray"> (LB)</span></label>
          <input
            type="number"
            class="input-container_input"
            formControlName="weight"
          />
        </div>
      </div>
    </div>

    <ng-container *ngIf="productId">
      <app-page-container-devider
        [title]="'Details'"
        [small]="true"
      ></app-page-container-devider>

      <div class="detail">
        <div class="detail_tabs">
          <app-vertical-tabs
            (actionEvent)="tabClicked($event)"
            [tabs]="['SKUs', 'Vendor Items', 'Orders', 'PO\'s', 'History']"
            [activeTab]="activeTab"
          ></app-vertical-tabs>
        </div>
        <div class="detail_content">
          <div class="detail_action" [hidden]="activeTab !== 'Vendor Items' && activeTab !== 'SKUs'">
            <app-button [hidden]="activeTab !== 'Vendor Items'" [buttonStyle]="'text'" (click)="newVendorItem()">New Vendor Item</app-button>
            <app-button [hidden]="activeTab !== 'SKUs'" [buttonStyle]="'text'" (click)="newMapping()">New Mapping</app-button>
          </div>
          <ag-grid-angular
            style="width: 100%;  height: 336px "
            class="ag-theme-alpine-po-detail"
            [gridOptions]="gridOptions"
            [columnDefs]="columnDefs"
            [modules]="modules"
            (gridReady)="gridReady($event)"
          >
          </ag-grid-angular>

        </div>
      </div>


    </ng-container>
  </div>
</app-dialog>
